import { useEffect, useState } from "react";
import base from "../middlewares/interceptors";
import { getUserAuthTagsUrl } from "../services/constants";

interface IUseFetchUserAuthTags {
  setIsLoading?: React.Dispatch<React.SetStateAction<boolean>>;
  userId: string | number | null | undefined;
}

const useFetchUserAuthTags = ({
  setIsLoading,
  userId,
}: IUseFetchUserAuthTags) => {
  const [userAuthTags, setUserAuthTags] = useState<number[]>([]);

  useEffect(() => {
    if (!userId) {
      setUserAuthTags([]);
      return;
    }

    const fetchUserAuthTags = async () => {
      if (setIsLoading) {
        setIsLoading(true);
      }

      try {
        const response = await base.get(
          `${getUserAuthTagsUrl}/${userId}/auth-tags?include_inactive=false`
        );

        setUserAuthTags(response.data || []);
      } catch (err) {
        console.error("Error fetching user tags:", err);
        setUserAuthTags([]);
      } finally {
        if (setIsLoading) {
          setIsLoading(false);
        }
      }
    };

    fetchUserAuthTags();
  }, [userId, setIsLoading]);

  return [userAuthTags, setUserAuthTags] as const;
};

export default useFetchUserAuthTags;
